import { format, formatDistanceToNow, isPast, parseISO } from 'date-fns';

export function formatDate(iso: string | undefined, pattern = 'MMM d, yyyy'): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), pattern);
  } catch {
    return iso;
  }
}

export function formatDateTime(iso: string | undefined): string {
  return formatDate(iso, 'MMM d, yyyy p');
}

export function relativeToNow(iso: string | undefined): string {
  if (!iso) return '—';
  try {
    return formatDistanceToNow(parseISO(iso), { addSuffix: true });
  } catch {
    return iso;
  }
}

export function isOverdue(dueDateIso: string | undefined, completed: boolean): boolean {
  if (!dueDateIso || completed) return false;
  try {
    return isPast(parseISO(dueDateIso));
  } catch {
    return false;
  }
}

export function nowIso(): string {
  return new Date().toISOString();
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}
